export default __webpack_public_path__ + "static/media/hungerformore.be300fea.png";